import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _com from "../../../assets/js/common";
import _intercept from "../../../assets/js/intercept";
import Progress from 'element-ui/lib/progress';
import 'element-ui/lib/theme-chalk/progress.css';
import jsonp from "../../../assets/js/http";

import QRCode from 'qrcodejs2'

Vue.component('el-progress', Progress)

@Component
export default class leftModal extends Vue {
	@Prop() diff: any = 0
	@Prop() activeGoodsData: any
	@Prop() roomData: any
	msg: any = '讲解中'
	refMsg: any = this.$refs.refMsg;
	showBur: any = false
	orderData: any = []
	orderList: any = []
	listNum: any = -1
	intervalTiemMsg: any
	intervalTiem: any
	showOrder: any = 0
	difference: number = 0;//本地时间与服务器时间差值
	api: any = {
		getBarrage: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/barrage/static/list", //获取弹幕信息
	}
	get recommendGoods() {
		//推荐商品
		let goods = this.$store.getters["refresh/getRecommend"];
		return this.recommendList(goods, 'recommend');
	}
	get goodsList() {
		//商品数据
		let goods = this.$store.getters["refresh/getGoodsList"];
		return this.recommendList(goods, 'goods');
	}
	@Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
	watchDiff(newVal: number) {
		this.difference = newVal;
	}
	created() {
		// if ((roomNumber == 204834 || roomNumber == 205087 || roomNumber == 206060) && location.href.indexOf('liveRealTime=show') > 0) {
		if (this.$route.params.roomNumber == '206060') {
			this.showOrder = 1
		}
		if (location.href.indexOf('liveRealTime=show') > 0) {
			this.showOrder = 2
			this.getOrderList()
		}
	}
	getOrderList() {
		let url = `https://datacube-api${process.env.VUE_APP_URI_DOMAIN}/api/liveSales/liveSaleBuyInfo?roomNum=${this.$route.params.roomNumber}`
		this.fetch({
			url,
		}).then((res: any) => {
			if (this.orderData.length == 0) this.orderData = res
			this.intervalTiem = setInterval(() => {
				this.listNum++
				if (this.listNum + 5 == this.orderData.length) {
					console.log(this.listNum)
					let url = `https://datacube-api${process.env.VUE_APP_URI_DOMAIN}/api/liveSales/liveSaleBuyInfo?roomNum=${this.$route.params.roomNumber}`
					this.fetch({
						url,
					}).then((res: any) => {
						this.orderData = this.orderData.concat(res)
					})
				}
				let scroll: any = this.$refs.orderList
				scroll.innerHTML += `<li>${this.orderData[this.listNum].transUsrPhone} 购买了 ${this.orderData[this.listNum].productName}</li>`
				scroll.children[this.listNum].style.cssText = 'display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;line-height: 1.5em;max-height: 42px;background: #494949;color: white;padding: 2%;border-radius: 11px;margin: 10px;'
				// if (this.$refs.orderList) scroll.scrollTop = scroll.scrollHeight
			}, 1000)
		})
	}
	destroyed() {
		clearInterval(this.intervalTiem)
		clearInterval(this.intervalTiemMsg)
	}
	mounted() {
		this.showBur = location.href.includes('borderless')
		this.creatQrCode(); // 创建二维码
		if (this.$refs.orderList) {
			let scroll: any = this.$refs.orderList
			this.intervalTiemMsg = setInterval(() => {
				scroll.scrollTop = scroll.scrollTop + 1
			}, 50)
		}
	}
	creatQrCode() {
		let ref: any = this.$refs.qrCodeUrl
		let long = document.documentElement.clientWidth * (136 / 375)
		new QRCode(ref, {
			text: location.href, // 二维码的内容
			width: long * 0.2,
			height: long * 0.2,
			colorDark: '#000',
			logoSrc: '../../../trend2Icon.png',
			colorLight: '#fff',
			correctLevel: QRCode.CorrectLevel.H
		});
	}
	recommendList(data: any, type: string) {
		if (JSON.stringify(data) === '{}' || data.length < 1) {
			return false
		} else {
			let nowTimes: number = new Date().getTime() + this.difference;
			if (type == 'recommend') { // 推荐商品
				if (data.endTime) { // 是否是秒杀
					if (nowTimes < data.startTime) { // 小于开始时间---未开始
						data.status = 0
					} else if (nowTimes >= data.startTime && nowTimes < data.endTime) { // 大于开始时间小于结束时间----已开始
						data.status = 1
					} else { // 大于结束时间---已结束
						data.status = 2
					}
				}
			}
			this.$forceUpdate()
			return data
		}
	}
}
